var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithubIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4013)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "url(#paint0_linear_1_4013)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_4013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0609 11.6575C20.435 10.585 19.5859 9.73595 18.5135 9.11005C17.4409 8.48413 16.27 8.17125 14.9999 8.17125C13.7299 8.17125 12.5586 8.48423 11.4863 9.11005C10.4138 9.73591 9.56476 10.585 8.9388 11.6575C8.31295 12.73 8 13.9012 8 15.1709C8 16.6962 8.44501 18.0678 9.33526 19.2861C10.2254 20.5044 11.3754 21.3474 12.785 21.8153C12.9491 21.8457 13.0706 21.8243 13.1495 21.7516C13.2286 21.6787 13.268 21.5875 13.268 21.4782C13.268 21.46 13.2664 21.296 13.2634 20.9861C13.2603 20.6761 13.2588 20.4057 13.2588 20.175L13.0492 20.2113C12.9155 20.2358 12.7469 20.2461 12.5433 20.2432C12.3398 20.2404 12.1286 20.219 11.9099 20.1794C11.6911 20.1401 11.4876 20.0489 11.2992 19.9062C11.1109 19.7634 10.9772 19.5764 10.8982 19.3457L10.8071 19.136C10.7463 18.9963 10.6507 18.8412 10.52 18.6712C10.3894 18.501 10.2572 18.3856 10.1236 18.3249L10.0598 18.2792C10.0172 18.2488 9.97779 18.2122 9.9413 18.1697C9.90484 18.1272 9.87755 18.0847 9.85932 18.0421C9.84106 17.9995 9.85619 17.9646 9.90487 17.9371C9.95356 17.9097 10.0415 17.8964 10.1692 17.8964L10.3514 17.9236C10.473 17.948 10.6233 18.0208 10.8026 18.1424C10.9818 18.2639 11.1291 18.4218 11.2446 18.6162C11.3844 18.8654 11.5529 19.0552 11.7505 19.1859C11.9479 19.3166 12.1469 19.3818 12.3474 19.3818C12.5479 19.3818 12.721 19.3666 12.8669 19.3364C13.0127 19.306 13.1494 19.2603 13.277 19.1996C13.3317 18.7923 13.4806 18.4794 13.7236 18.2607C13.3773 18.2243 13.0659 18.1695 12.7894 18.0966C12.513 18.0236 12.2274 17.9052 11.9327 17.741C11.6379 17.577 11.3933 17.3733 11.199 17.1304C11.0045 16.8873 10.845 16.5682 10.7205 16.1734C10.596 15.7784 10.5337 15.3227 10.5337 14.8062C10.5337 14.0709 10.7738 13.4451 11.2538 12.9286C11.0289 12.3757 11.0502 11.756 11.3175 11.0694C11.4938 11.0146 11.7551 11.0557 12.1014 11.1924C12.4478 11.3291 12.7014 11.4462 12.8625 11.5433C13.0235 11.6404 13.1526 11.7227 13.2498 11.7894C13.815 11.6315 14.3983 11.5525 14.9998 11.5525C15.6013 11.5525 16.1847 11.6315 16.75 11.7894L17.0963 11.5707C17.3331 11.4249 17.6128 11.2912 17.9347 11.1696C18.2567 11.0482 18.503 11.0147 18.6732 11.0695C18.9465 11.7561 18.9709 12.3758 18.7459 12.9287C19.2259 13.4452 19.4661 14.0711 19.4661 14.8063C19.4661 15.3228 19.4036 15.7799 19.2793 16.1779C19.1548 16.5761 18.9938 16.8948 18.7964 17.135C18.5988 17.3751 18.3526 17.5771 18.058 17.7411C17.7633 17.9052 17.4776 18.0236 17.2012 18.0966C16.9246 18.1695 16.6133 18.2244 16.267 18.2608C16.5828 18.5342 16.7408 18.9656 16.7408 19.555V21.478C16.7408 21.5872 16.7788 21.6784 16.8548 21.7513C16.9308 21.8241 17.0507 21.8455 17.2148 21.815C18.6246 21.3472 19.7746 20.5041 20.6647 19.2858C21.5547 18.0676 21.9999 16.696 21.9999 15.1707C21.9996 13.9011 21.6865 12.73 21.0609 11.6575Z",
    fill: "#1E202A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4013",
    x1: 0,
    y1: 0,
    x2: 35.5334,
    y2: 9.6726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABB18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C48E02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_4013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/github-icon.f95f3bc39bae7af00429c6f0aad6ee0c.svg";
export { ForwardRef as ReactComponent };